export default __webpack_public_path__ + "static/media/instagram.172f3110.svg";